import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useCacheHttp() {
  return {
    cacheHttp: GlobalPrototypes.cacheHttp,
  }
}
